import { useRef } from 'react';

import { deepEqual } from '../utilities/deepEqual';

export function useDeepCompareMemoize<T>(value: T): T {
    const ref = useRef<T>(value);

    if (!deepEqual(ref.current, value)) {
        ref.current = value;
    }

    return ref.current;
}
